// extracted by mini-css-extract-plugin
module.exports = {"timePart":"Countdown_timePart__zdqEv","hidden":"Countdown_hidden__f1SNE"};